import {useState} from "react";
import {trackProduct, untrackProduct} from "../infrastructure/productApi";
import {isSuccess} from "../../common/domain/RemoteData.model";
import {useComercialContext} from "../../comercial/ComercialContext";

export const useTrackingProduct = (productCode, defaultIsTracked) => {
    const [isTracked, setIsTracked] = useState(defaultIsTracked);
    const {actingAsCliente} = useComercialContext();

    const handleTrack = async (onSuccessFn, onFailureFn, quantity = 1) => {
        try {
            const result = await trackProduct(productCode, quantity, actingAsCliente?.numCliente);
            if (isSuccess(result)) {
                onSuccessFn();
                setIsTracked(true);
            } else {
                onFailureFn();
            }
        } catch (e) {
            onFailureFn();
        }
    }

    const handleUntrack = async (onSuccessFn, onFailureFn) => {
        try {
            const result = await untrackProduct(productCode, actingAsCliente?.numCliente);
            if (isSuccess(result)) {
                onSuccessFn();
                setIsTracked(false);
            } else {
                onFailureFn();
            }
        } catch (e) {
            onFailureFn();
        }
    }

    return {isTracked, handleTrack, handleUntrack};
};
